<template>
  <div>
    <b-modal
      ref="my-modal"
      centered
      :show.sync="isActiveLocal"
      header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
      modal-content-classes="cust-medi-popup cust-overflow-y-grey cust-close-pop"
      hide-footer
      class="overflow-y-hidden"
    >
      <template slot="modal-title">
        <h3
          class="lg:text-xl md:text-xl text-lg font-semibold text-white bg-primary"
        >
          Bank Transfer Details :
        </h3></template
      >
      <div class="d-block text-left">
        <p class="fsize16 sm-fsize14">
          Friends of Caregiver Saathi is a U.S.-based organization dedicated to
          supporting the vital work of the Caregiver Saathi Foundation in India.
          We are committed to empowering family caregivers across South Asia,
          with a special focus on women.<br /><br />
          Tax payer ID: 87-3617959<br />
          Account number: 8565018457<br />
          The name on your account as it appears<br />
          on your statement. Friends of Caregiver Saathi<br />
          Bank name: Wells Fargo Bank <br />
          Bank address: 420 Montgomery Street San Francisco CA 94104<br />
          For domestic (U.S.) wire: Wire routing transit number/ABA: 121000248
          <br />
          For international wire sent in U.S. dollars or if the currency the
          wire is being sent in is unknown: SWIFT Code: WFBIUS6S<br />
          For international wire sent in a foreign currency from the initiating
          bank: SWIFT Code: WFBIUS6WFFX <br />
          <br />
          You can send the cheque to: Friends of Caregiver Saathi 867 Dwight
          Ave, Sunnyvale, CA-94086
        </p>
      </div>
    </b-modal>
    <div
      class="flex justify-center text-justify lg:w-6/12 mx-auto lg:mt-10 md:mt-6 mt-4"
    >
      <div>
        <h2
          class="text-black text-center lg:text-2xl md:text-2xl text-xl font-bold"
        >
          You can help by Donating
        </h2>
        <p class="mt-2 fsize14 smfsize10">
          Your Donation to the Caregiver Saathi Foundation supports our
          advocacy, awareness and training programmes for family caregivers.
          <br />
          Support us monthly through our monthly giving program, where you can
          automatically donate a specific amount to us every month. Every Month
          a small amount of donation from you will be a significant amount for
          us.
        </p>
      </div>
    </div>
    <div class="flex justify-center text-justify lg:w-6/12 mx-auto">
      <div class="w-full">
        <div class="mt-8">
          <h2
            class="text-black text-center lg:text-2xl md:text-2xl text-xl font-bold"
          >
            For International Donors (USA-Based):
          </h2>
          <p class="text-justify py-6">
            You can send us your contribution via our support organisation in
            the USA – Friends of Caregiver Saathi. As a registered 501(c)(3)
            organization, donations are tax-deductible to the extent allowed by
            law.
          </p>
          <!-- <div class="flex justify-center">
            <b-button
              variant="primary"
              id="show-btn"
              @click="showModal"
              class="lg:my-0 md:my-0 my-4"
            >
              Know More
            </b-button>
          </div> -->
        </div>
      </div>
    </div>
    <div class="flex justify-center text-justify lg:w-6/12 mx-auto">
      <div class="w-full">
        <div class="mt-4">
          <h2
            class="text-black text-center lg:text-2xl md:text-2xl text-xl font-bold"
          >
            Bank Transfer Details :
          </h2>
          <br />
          <p class="fsize16 sm-fsize14">
            Friends of Caregiver Saathi is a U.S.-based organization dedicated
            to supporting the vital work of the Caregiver Saathi Foundation in
            India. We are committed to empowering family caregivers across South
            Asia, with a special focus on women.<br /><br />
            Tax payer ID: 87-3617959<br />
            Account number: 8565018457<br />
            The name on your account as it appears<br />
            on your statement. Friends of Caregiver Saathi<br />
            Bank name: Wells Fargo Bank <br />
            Bank address: 420 Montgomery Street San Francisco CA 94104<br />
            For domestic (U.S.) wire: Wire routing transit number/ABA: 121000248
            <br />
            For international wire sent in U.S. dollars or if the currency the
            wire is being sent in is unknown: SWIFT Code: WFBIUS6S<br />
            For international wire sent in a foreign currency from the
            initiating bank: SWIFT Code: WFBIUS6WFFX <br />
            <br />
            You can send the cheque to: Friends of Caregiver Saathi 867 Dwight
            Ave, Sunnyvale, CA-94086
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
  },
};
</script>
<style>
.modal-header {
  background-color: #4f0a4b;
}
</style>
